import React from 'react';

import * as S from './PassportTooltip.styles';

const PassportTooltip = ({
    imgUrl,
    text,
    onClose
}) => {
    return (
        <S.Container>
            <S.TooltipClose onClick={onClose}></S.TooltipClose>
            {imgUrl && <S.PlaceholderImg src={imgUrl} alt="" />}
            {text && <S.PlaceholderText>{text}</S.PlaceholderText>}
        </S.Container>
    )
}

export default PassportTooltip;